import { useRef, useState } from "react";
import IconArrowLeft from "../../../components/icons/icon-arrow";

interface VerifyOtpComponentProps {
  setValueOtp: (value: string) => void;
  isLoading?: boolean;
  backWardForm: () => void;
}

export const VerifyOtpComponent = ({ setValueOtp, isLoading, backWardForm }: VerifyOtpComponentProps) => {
  const [otpCode, setOtpCode] = useState<string[]>(Array(6).fill(""));
  const [isShowError, setIsShowError] = useState(false);
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleSendOtp = () => {
    if (otpCode.includes("")) {
      setIsShowError(true);
      return;
    }
    setIsShowError(false);
    setValueOtp(otpCode.join(""));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Enter") {
      handleSendOtp();
    }
    if (e.key === "Delete" || e.key === "Backspace") {
      if (index > 0 && !otpCode[index]) {
        // Move focus to the previous input
        inputsRef.current[index - 1]?.focus();
      }

      setOtpCode((prevOtpCode) => {
        const newOtpCode = [...prevOtpCode];
        newOtpCode[index] = ""; // Clear the current input value
        return newOtpCode;
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { value } = e.target;

    if (/^\d*$/.test(value)) {
      setOtpCode((prevOtpCode) => {
        const newOtpCode = [...prevOtpCode];
        newOtpCode[index] = value;
        return newOtpCode;
      });

      // Move focus to the next input
      if (value !== "" && index < inputsRef.current.length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  return (
    <>
      <header className="mb-8">
        <button onClick={() => backWardForm()} data-testid="button-otp-back">
          <IconArrowLeft className="w-6 h-6 rotate-180" />
        </button>
        <h1 className="mb-1 text-2xl font-bold text-center">Xác minh tài khoản</h1>
        <p className="text-[15px] text-slate-500 text-center">
          Nhập mã xác minh gồm 6 chữ số đã được gửi tới Google Authenticator của bạn.
        </p>
      </header>
      <form className="space-y-5" data-testid="verify-otp-form">
        <div className="flex items-center justify-center gap-3">
          {Array.from({ length: 6 }, (_, index) => (
            <input
              key={index}
              autoFocus={index === 0}
              type="text"
              ref={(el) => (inputsRef.current[index] = el)}
              className="p-4 text-2xl font-extrabold text-center border border-gray-400 rounded outline-none appearance-none w-14 h-14 text-slate-900 bg-slate-100 hover:border-slate-200 focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
              maxLength={1}
              value={otpCode[index]}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onChange={(e) => handleChange(e, index)}
            />
          ))}
        </div>
        {isShowError && <p className="text-center text-red-500">Vui lòng nhập đầy đủ mã xác minh</p>}
        <button
          type="button"
          className="btn btn-gradient w-full border-0 shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]"
          onClick={handleSendOtp}
          disabled={isLoading}
        >
          {isLoading && (
            <span className="inline-block w-5 h-5 align-middle border-2 border-white rounded-full animate-spin border-l-transparent ltr:mr-4 rtl:ml-4"></span>
          )}
          Xác minh tài khoản
        </button>
      </form>
    </>
  );
};
